module.exports = __webpack_public_path__ + "static/media/dbt.95d59d47.svg";